import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { SelectSearchComponent } from 'shared/modules/controls/select-search/select-search.component';
import { MaterialModule } from 'shared/modules/material/material.module';

@NgModule({
  declarations: [SelectSearchComponent],
  imports: [
    TranslateModule,
    MaterialModule,
    AngularModule,
  ],
  exports: [SelectSearchComponent],
})
export class SelectSearchModule {
}
